import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { cssVars } from "../theme";
import Logo from "../assets/Pi7_Tool_whitelogo.png";
import "./HlcSiteFooter.css";

const YEAR = new Date().getFullYear();

/* Exact same categories/links/hrefs as the previous footer — presentation
   only changes below, nothing here is new or altered. */
const LINKS = {
  shop: [
    { text: "Shop Now", href: "/shop" },
    { text: "Categories", href: "/categories" },
    { text: "Solutions", href: "/solutions" },
    { text: "Calculator", href: "/calculator" },
  ],
  support: [
    { text: "FAQs", href: "/faqs" },
    { text: "Warranty", href: "/warranty" },
    { text: "Shipping & Returns", href: "/shipping-returns" },
    { text: "Store Locator", href: "/store-locator" },
  ],
  company: [
    { text: "About HLC", href: "/about-hlc" },
    { text: "News & Events", href: "/news-events" },
    { text: "Careers", href: "/careers" },
  ],
  guides: [
    { text: "LED Basics", href: "/led-basics" },
    { text: "Home Lighting Tips", href: "/home-lighting-tips" },
    { text: "Energy Savings", href: "/energy-savings" },
    { text: "Outdoor & Floods", href: "/outdoor-floods" },
    { text: "Rope Light Ideas", href: "/rope-light-ideas" },
  ],
  legal: [
    { text: "Privacy Policy", href: "/privacy-policy" },
    { text: "Terms & Conditions", href: "/terms-of-use" },
    { text: "SiteMap", href: "/site-map" },
    { text: "Your Privacy Rights", href: "/privacy-rights" },
    { text: "Accessibility", href: "/accessibility" },
    { text: "Cookie Notice", href: "/cookie-notice" },
  ],
};

/* Same social hrefs/icons used by the consultation section above — reused
   verbatim, not re-invented. */
const SOCIAL_LINKS = [
  {
    href: "https://www.facebook.com/HLCPK1/",
    aria: "Facebook",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987H7.898v-2.89h2.54V9.845c0-2.507 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562v1.875h2.773l-.443 2.89h-2.33V21.88C18.343 21.128 22 16.991 22 12z" />
      </svg>
    ),
  },
  {
    href: "https://www.instagram.com/hlcpk/",
    aria: "Instagram",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
      </svg>
    ),
  },
  {
    href: "https://www.linkedin.com/company/high-lite-concern/",
    aria: "LinkedIn",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
  {
    href: "https://wa.me/923702961896",
    aria: "WhatsApp",
    icon: (
      <svg viewBox="0 0 32 32" fill="currentColor">
        <path d="M19.11 17.21c-.27-.14-1.58-.78-1.82-.87-.24-.09-.42-.14-.6.14-.18.27-.69.87-.85 1.05-.16.18-.31.2-.58.07-.27-.14-1.13-.42-2.16-1.33-.8-.71-1.34-1.58-1.5-1.85-.16-.27-.02-.41.12-.54.12-.12.27-.31.4-.47.13-.16.18-.27.27-.45.09-.18.04-.34-.02-.47-.07-.14-.6-1.45-.82-1.98-.22-.53-.44-.46-.6-.47h-.51c-.18 0-.47.07-.71.34-.24.27-.93.91-.93 2.22s.95 2.58 1.08 2.76c.13.18 1.87 2.85 4.53 4 .63.27 1.13.43 1.51.55.64.2 1.22.17 1.68.1.51-.08 1.58-.65 1.8-1.28.22-.63.22-1.17.16-1.28-.07-.11-.24-.18-.51-.31z" />
        <path d="M16.01 3C8.83 3 3 8.82 3 16c0 2.53.74 4.98 2.14 7.08L3 29l6.1-2.09A12.93 12.93 0 0 0 16.01 29C23.18 29 29 23.18 29 16S23.18 3 16.01 3zm0 23.67c-2.15 0-4.25-.58-6.09-1.68l-.44-.26-3.62 1.24 1.18-3.53-.29-.46A10.62 10.62 0 0 1 5.33 16c0-5.89 4.79-10.68 10.68-10.68S26.69 10.11 26.69 16 21.9 26.67 16.01 26.67z" />
      </svg>
    ),
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

function FooterColumn({ title, items }) {
  return (
    <div className="hsf__col">
      <h4>{title}</h4>
      <ul>
        {items.map((link) => (
          <li key={link.href}>
            <Link to={link.href}>{link.text}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function HlcSiteFooter() {
  return (
    <footer className="hsf" style={cssVars}>
      <div className="hsf__atmosphere" aria-hidden="true">
        <div className="hsf__glow hsf__glow--magenta" />
        <div className="hsf__glow hsf__glow--gold" />
      </div>

      <div className="hsf__wrap">
        <div className="hsf__top">
          <motion.div
            className="hsf__brand"
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.4 }}
          >
            <img src={Logo} alt="HLC Lighting" className="hsf__logo" />
            <p className="hsf__tagline">
              Premium LED lighting solutions designed for homes, offices,
              commercial spaces and architectural environments.
            </p>

            <div className="hsf__social">
              <span className="hsf__social-label">Follow HLC</span>
              <div className="hsf__social-row">
                {SOCIAL_LINKS.map((soc) => (
                  <a
                    key={soc.aria}
                    href={soc.href}
                    aria-label={soc.aria}
                    title={soc.aria}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hsf__soc-link"
                  >
                    {soc.icon}
                  </a>
                ))}
              </div>
            </div>
          </motion.div>

          <motion.div
            className="hsf__columns"
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
          >
            <FooterColumn title="Shop" items={LINKS.shop} />
            <FooterColumn title="Support" items={LINKS.support} />
            <FooterColumn title="Company" items={LINKS.company} />
            <FooterColumn title="Lighting Guides" items={LINKS.guides} />
          </motion.div>
        </div>

        <div className="hsf__statement">
          <span>Light Better.</span> <span className="hsf__statement-accent">Live Better.</span>
        </div>
      </div>

      <div className="hsf__bottom">
        <div className="hsf__bottom-inner">
          <p className="hsf__copyright">© {YEAR} HLC Lighting. All rights reserved.</p>

          <ul className="hsf__legal">
            {LINKS.legal.map((link) => (
              <li key={link.href}>
                <Link to={link.href}>{link.text}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
}
